import { ComponentPropsWithoutRef, ReactNode } from "react";
import * as styles from "./styles";

export interface FeelCardProps extends ComponentPropsWithoutRef<"div"> {
  title: string;
  description: string;
  icon: ReactNode;
  logo: ReactNode;
}

export const FeelCard = ({
  title,
  description,
  icon,
  logo,
  ...props
}: FeelCardProps) => {
  return (
    <div css={styles.card} {...props}>
      <div css={styles.icon}>{icon}</div>
      <p css={styles.title}>{title}</p>
      <div css={styles.logo}>{logo}</div>
      <p css={styles.description}>{description}</p>
    </div>
  );
};
